module.exports = __webpack_public_path__ + "media/images/skoda-ec197fdc.png";